import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../Shared/Redux/store';
const initialState = {
  editSessionData: null,
  isAddSessionModalOpen: false,
  isMakeActiveModalOpen: false,
  modalMode: '',
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setEditSessionData: (state, action: PayloadAction<any>) => {
      state.editSessionData = action.payload;
    },

    setIsAddSessionModalOpen: state => {
      state.isAddSessionModalOpen = !state.isAddSessionModalOpen;
    },
    setIsMakeActiveModalOpen: state => {
      state.isMakeActiveModalOpen = !state.isMakeActiveModalOpen;
    },
    setModalMode: (state, action: PayloadAction<any>) => {
      state.modalMode = action.payload;
    },
  },
});

export const selectIsAddSessionModalOpen = (state: RootState) =>
  state.session.isAddSessionModalOpen;

export const selectEditSessionData = (state: RootState) =>
  state.session.editSessionData;

export const selectIsMakeActiveModalOpen = (state: RootState) =>
  state.session.isMakeActiveModalOpen;

export const selectModalMode = (state: RootState) => state.session.modalMode;

export const { setEditSessionData, setIsAddSessionModalOpen } =
  sessionSlice.actions;
export default sessionSlice.reducer;
